import _ from "lodash";
import { getLoader } from "../root.selectors";

export const getIsLoaderShown = _.flow([
  getLoader,
  ({ loadersShown }) => loadersShown > 0,
]);
